<template>
    <div class="vw-100 h-100 d-flex flex-row">
        <aside class="left">
            <div class="header py-2 px-3" style="z-index: 99">
                <a class="me-2 fs-3 text-dark cp btn-rounded btn-default btn d-block d-lg-none" @click="toggle"><i class="mdi mdi-arrow-left"></i></a>
                <h5 class="m-0">Vikipedia</h5>
                <div class="flex-1 d-flex flex-row justify-content-end align-items-center">
                    <button class="btn btn-default btn-rounded text-primary" @click="$emitter.emit('show_add_topic', {callback:addTopic});" v-if="getRole === 'A'"><i class="mdi mdi-plus-circle fs-20"></i></button>
                    <button class="btn btn-default btn-rounded" @click="refresh"><i class="mdi mdi-refresh fs-20"></i></button>
                </div>
            </div>
            <div class="flex-1 position-relative w-100 h-100">
                <div class="position-absolute w-100 h-100 overflow-auto pt-0 p-3" v-if="menus.length > 0 && !menus_loading">
                    <nav class="nav nav-pills flex-column side-menu" :data-uid="menu.uid" v-for="(menu, index) in menus" :key="index">
                        <div class="nav-link mw-100" :class="{'nav-active':menu.uid == $route.params.child_id}" @mouseover="hover[menu.uid] = true" @mouseout="hover[menu.uid] = false">
                            <span class="d-flex align-items-start w-100 mw-100 nav-link-child text-truncate">
                                <span @click="$router.replace(`/vikipedia/${menu.uid}`);toggleRight();" class="w-100">{{menu.name}}</span>
                            </span>


                            <div v-show="hover[menu.uid]" v-if="menu.admin === true">
                                <div class="d-flex flex-row">
                                    <div class="dropdown">
                                        <a class="option-item dropdown-toggle text-dark" data-bs-toggle="dropdown"><i class="mdi mdi-dots-vertical"></i></a>
                                        <ul class="dropdown-menu">
                                            <li><button class="dropdown-item" type="button" @click="$emitter.emit('show_add_topic', {callback:updateTopic,data:menu.name,parent:menu.id});"><i class="mdi mdi-pencil"></i> Edit</button></li>
                                            <li><button class="dropdown-item" type="button" @click="$emitter.emit('delete_modal_show', [deleteTopic, menu.id]);"><i class="mdi mdi-trash-can"></i> Move to Trash</button></li>
                                        </ul>
                                    </div>
                                    <a class="option-item text-primary" @click="$emitter.emit('show_add_topic', {callback:addTopic,parent:menu.id});"><i class="mdi mdi-plus-circle"></i></a>  
                                </div>
                            </div>

                            <a class="option-item me-2 arrow" v-if="menu.menu.length > 0" @click="show[menu.uid] = !show[menu.uid];">
                                <i class="mdi" :class="{'mdi-chevron-down':!show[menu.uid], 'mdi-chevron-up':show[menu.uid]}"></i>
                            </a>
             

                        </div>
                        <transition name="fade">
                            <SubMenuVP :menus="menu.menu" :index="menu.uid" v-show="show[menu.uid]"/>
                        </transition>
                    </nav>
                </div>
                <div class="w-100 h-100 d-flex flex-column p-3 opacity-3" v-else-if="menus_loading">
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                </div>
                <div class="w-100 h-100 d-flex flex-column align-items-center justify-content-center opacity-3" v-else>
                    <i class="mdi mdi-menu h-auto" style="font-size: 100px;"></i>
                    <span class="fw-500">No menus found</span>
                </div>
            </div>
            <div class="d-grid gap-1 p-1" v-if="getRole === 'A'">
                <button class="btn btn-danger text-start" disabled><i class="mdi mdi-trash-can mx-2"></i>Trash</button>
            </div>
        </aside>
        <div class="container align-items-center d-flex flex-column position-relative">
            <button class="btn btn-secondary position-fixed d-block d-lg-none" style="top: 110px; left:10px;z-index:1" @click="toggle">Menu</button>
            <div class="position-absolute overflow-auto w-100 h-100 bg-white">
                <div class="px-3 py-lg-3 h-100 ql-editor content-container" style="padding-top: 10%;" v-if="getContent !== ''" v-html="getContent">
                </div>
                <div class="w-100 h-100 d-flex flex-column align-items-center justify-content-center" style="background: #fdfdfd;" v-else>
                    <img src="../assets/v_parent/vp.gif" />
                </div>
            </div>
        </div>
        <aside class="right">
            <div class="header py-2 px-3" style="z-index: 99">
                <a class="me-2 fs-3 text-dark cp btn-rounded btn-default btn d-block d-lg-none" @click="toggleRight"><i class="mdi mdi-arrow-left"></i></a>
                <h5 class="m-0 my-3">Content</h5>
                <div class="flex-1 d-flex flex-row justify-content-end align-items-center" v-if="$route.params.child_id !== undefined">
                    <button class="btn btn-default btn-rounded text-primary" @click="$emitter.emit('show_add_vp', {callback:addContent});" v-if="getRole === 'A'"><i class="mdi mdi-plus-circle fs-20"></i></button>
                    <button class="btn btn-default btn-rounded" @click="refreshContent"><i class="mdi mdi-refresh fs-20"></i></button>
                </div>
            </div>
            <div class="flex-1 position-relative w-100 h-100">
                <div class="position-absolute w-100 h-100 overflow-auto pt-0 p-3" v-if="submenus.length > 0 && !submenus_loading">
                    <nav class="nav nav-pills flex-column side-menu" v-for="(menu, index) in submenus" :key="index">
                        <div class="nav-link mw-100" :class="{'nav-active':menu.uid == $route.query.content}" @mouseover="hover[menu.uid] = true" @mouseout="hover[menu.uid] = false">
                            <span class="d-flex align-items-center w-100 mw-100 nav-link-child text-truncate" @click="$router.replace({query:{content:menu.uid}})">
                                {{menu.content_name}}
                            </span>
                            <div v-show="hover[menu.uid]" v-if="menu.admin === true">
                                <div class="d-flex flex-row">
                                    <div class="dropdown">
                                        <a class="option-item dropdown-toggle text-dark" data-bs-toggle="dropdown"><i class="mdi mdi-dots-vertical"></i></a>
                                        <ul class="dropdown-menu">
                                            <li><button class="dropdown-item" type="button" @click="$emitter.emit('show_add_vp', {callback:updateContent,data:{index:index, title:menu.content_name,content:menu.content}});"><i class="mdi mdi-pencil"></i> Edit</button></li>
                                            <li><button class="dropdown-item" type="button" @click="copyURL(menu.uid)"><i class="mdi mdi-link"></i> Get Url</button></li>
                                            <li><button class="dropdown-item" type="button" @click="$emitter.emit('delete_modal_show', [deleteContent, menu.id]);"><i class="mdi mdi-trash-can"></i> Move to Trash</button></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
                <div class="w-100 h-100 d-flex flex-column p-3 opacity-3" v-else-if="submenus_loading">
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                    <div class="w-100 shimmer mb-2" style="height: 28px;"></div>
                </div>
                <div class="w-100 h-100 d-flex flex-column align-items-center justify-content-center opacity-3" v-else>
                    <i class="mdi mdi-menu h-auto" style="font-size: 100px;"></i>
                    <span class="fw-500">Click on left side pane or no content found</span>
                </div>
            </div>
        </aside>
    </div>

    <AddVikipediaModal />
    <DefinitionModal />

    <magnific-popup-modal :show="image !== ''" :config="{closeOnBgClick:false}" ref="modal">
        <div v-html="image"></div>
    </magnific-popup-modal>

</template>

<script>
import SubMenuVP from './subviews/SubMenuVP';
import AddVikipediaModal from './modal/AddVikipediaModal';
import DefinitionModal from './modal/DefinitionModal';
import MagnificPopupModal from './modal/MagnificPopupModal';

export default {
    components: {
        SubMenuVP,
        AddVikipediaModal,
        DefinitionModal,
        MagnificPopupModal
    },
    data() {
        return {
            announcements: [],
            appname: process.env.VUE_APP_APPNAME,
            menus_loading: true,
            menus: [],
            submenus_loading: false,
            submenus: [],
            hover: {},
            show: {},
            temp: [],
            mounted: false,
            image: ''
        }
    },
    computed: {
        getContent() {
            let id = this.$route.query.content;
            let content = '';
            
            if(id == undefined) content = '';
            else {
                for(var i = 0; i < this.submenus.length; i++) {
                    var d = this.submenus[i];
                    if(d.uid == id) {
                        return d.content;
                    }
                }
            }

            return content;
        },
        getRole() {
            try {
                var json = JSON.parse(localStorage.getItem('versatechvex_data'));
                if(json.role !== undefined) return json.role;
                else return 'U';
            }
            catch(e) {
                return 'U';
            }
        }
    },
    methods: {
        copyURL(id = '') {
            var dummy = document.createElement("textarea");
            // to avoid breaking orgain page when copying more words
            // cant copy when adding below this code
            // dummy.style.display = 'none'
            document.body.appendChild(dummy);
            //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
            dummy.value =  window.location.protocol+'//'+window.location.host+`/vikipedia/${this.$route.params.child_id}`+(id == '' ? '' : '?content='+id);
            dummy.select();
            document.execCommand("copy");
            document.body.removeChild(dummy);
            this.$jlalert.show('Url copied', false);
        } ,
        toggle() {
            let aside = document.querySelector('aside.left');
            if(aside !== null) {
                if(aside.classList.contains('show')) aside.classList.remove('show');
                else aside.classList.add('show');
            }
        },
        toggleRight() {
            // if(this.submenus.length <= 0) return;

            let aside = document.querySelector('aside.right');
            if(aside !== null) {
                if(aside.classList.contains('show')) aside.classList.remove('show');
                else aside.classList.add('show');
            }
        },
        open(index) {
            let details = document.querySelector('.details');
            if(index == -1) {
                this.$refs.container.innerHTML = '';
                this.$refs.container_title = '';
                details.classList.remove('show');
            }
            else {
                details.classList.add('show');
                this.$refs.container_title.innerHTML = index.content_name;
            }
        },
        async openTopic(uid) {
            await this.$axios.get(`/content/vikipedia/${uid}`)
                    .then((res) => {
                        this.submenus = res.data;
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
            this.submenus_loading = false;
        },
        openDef(link) {
            this.$emitter.emit('show_definition', link);
        },
        async loadMenus(load = false) {
            if(load == true) this.menus_loading = true;
            
            await this.$axios.get('/menus/vikipedia')
                    .then((res) => {
                        this.menus = res.data;
                        
                        if(this.$route.params.child_id) this.openTopic(this.$route.params.child_id);
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
            this.menus_loading = false;
        },
        refresh() {
            this.menus = [];
            this.submenus = [];
            this.submenus_loading = true;
            if(this.$route.params.child_id !== undefined) this.openTopic(this.$route.params.child_id);
            else this.submenus_loading = false;

            this.loadMenus(true);
        },
        refreshContent() {
            this.submenus = [];
            this.submenus_loading = true;
            if(this.$route.params.child_id !== undefined) this.openTopic(this.$route.params.child_id);
        },
        closeel(element) {
            if(element == null) return;
            var parent = element.parentElement;
            var nav = parent.parentElement;
            if(nav.tagName == 'NAV') {
                this.temp.push(nav);
                let link = nav.querySelectorAll('.nav-link');
                if(link[0] !== null && link[0] !== undefined) {
                    this.closeel(nav);
                }
            }
            else this.initClick();
        },
        initClick() {
            for (var i = this.temp.length - 1; i >= 0; i--) {
                let target = this.temp[i];
                let link = target.querySelectorAll('.nav-link');
                if(link[0] !== null && link[0] !== undefined) {
                    let item = link[0].querySelectorAll('.arrow');
                    if(item[0] !== null && item[0] !== undefined) {
                        let arrow = link[0].querySelector('.arrow');
                        if(arrow !== null && arrow !== undefined) {
                            arrow.click();
                        }
                    }
                }
            }
        },
        reset() {
            this.submenus_loading = true;
            this.submenus = [];
        },
        async addTopic(topic, parent = '') {
            if(topic.toString().length == 0) return this.$jlalert.show('Topic cannot be empty');
            await this.$axios.post('/menus/vikipedia', this.$qs.stringify({topic:topic,parent:parent}))
                    .then((res) => {
                        if(res.status == 200) {
                            //this.menus = [];
                            this.loadMenus();
                        }
                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
        },
        async deleteTopic(id) {
            await this.$axios.delete(`/menus/vikipedia/${id}`)
                    .then((res) => {
                        if(res.status == 200) {
                            this.$router.replace('/vikipedia');
                            this.loadMenus();
                        }
                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    })
        },
        async updateTopic(topic, id) {
            await this.$axios.post('/menus/vikipedia/update', this.$qs.stringify({topic:topic,id:id}))
                    .then((res) => {
                        if(res.status == 200) {
                            //this.menus = [];
                            this.loadMenus();
                        }  

                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$$jlalert.show(err);
                    });
        },
        async addContent(index, title, content) {
            await this.$axios.post('/content/vikipedia/insert', this.$qs.stringify({content:content,title:title,id:this.$route.params.child_id}))
                    .then((res) => {
                        if(res.status == 200) this.openTopic(this.$route.params.child_id);
                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    })
        },
        async updateContent(index, title, content) {

            console.log('content',content)
            console.log('index',index)

            console.log('title',title)

            await this.$axios.post('/content/vikipedia/update', this.$qs.stringify({id:this.submenus[index].id,title:title,content:content}))
                    .then((res) => {
                        if(res.status == 200) {
                            this.submenus[index].content_name = title;
                            this.submenus[index].content = content;
                        }
                        this.$jlalert.show(res.data, (res.status !== 200));

                        // console.log(res)
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    })
                    
        },
        async deleteContent(id) {
            await this.$axios.delete(`/content/vikipedia/${id}`)
                    .then((res) => {
                        if(res.status == 200) {
                            this.$router.replace({query:{}});
                            for(var i = 0; i < this.submenus.length; i++) {
                                var d = this.submenus[i];                       
                                if(d.id == id) {
                                    this.submenus.splice(i, 1);
                                    return;
                                }
                            }
                        }
                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    })
        },
        defClick(e) {
            if(e.path) {
                let found = [];
                
                e.path.forEach(element => {
                    if(element.tagName === 'A') found.push(element);
                    if(element.classList !== undefined && element.classList.contains('content-container'))  found.push(element);
                });
                
                if(found.length == 2) {
                    e.preventDefault();
                    this.openDef(e.path[1].getAttribute('href'));
                }
            }
        }
    },
    mounted() {
        this.mounted = true;
        this.loadMenus(true);

        this.$emitter.on('addTopicVP', (data) => {
            this.addTopic(data[0], data[1]);
        });

        this.$emitter.on('updateTopicVP', (data) => {
            this.updateTopic(data[0], data[1]);
        });

        this.$emitter.on('deleteTopicVP', (data) => {
            this.deleteTopic(data);
        });

        this.$emitter.on('openTopicVP', (data) => {
            this.$router.replace(`/vikipedia/${data}`);
        });

        this.$emitter.on('toggleRight', () => {
            this.toggleRight();
        })
    },
    activated() {
        this.temp = [];
        this.show = {};
        this.$emitter.emit('show_reset');

        if(this.menus !== undefined) {
            if(this.menus.length) {
                setTimeout(() => {
                    var element = document.querySelector(`[data-uid="${this.$route.params.child_id}"]`);
                    this.closeel(element);
                }, 200);
            }
        }

        document.addEventListener("click", this.defClick);
    },
    deactivated() {
        document.removeEventListener("click", this.defClick);
    },
    watch: {
        "$route.params.child_id": function(n) {
            this.reset();
            if(n == undefined) {
                this.submenus_loading = false;
                return;
            }
            this.openTopic(n)
            let details = document.querySelector('.details');
            if(details !== null && details !== undefined) details.classList.remove('show');
        },
        "$route.query.content": function(n) {
            if(n !== undefined) {
                let aside = document.querySelector('aside.left');
                if(aside !== null) {
                    aside.classList.remove('show');
                }

                let asider = document.querySelector('aside.right');
                if(asider !== null) {
                    asider.classList.remove('show');
                }
            }
        },
        "menus": function(n) {
            if(n.length > 0 && this.$route.params.child_id !== undefined) {
                setTimeout(() => {
                    var element = document.querySelector(`[data-uid="${this.$route.params.child_id}"]`);
                    this.closeel(element);
                }, 500);
            }

            //GET CONTENT
            if(this.mounted) {
                if(this.$route.query.content !== undefined) {
                    this.openTopic(this.$route.params.child_id);
                }
            }
        },
        "submenus": function(n) {
           if(n.length > 0) this.toggleRight();
        }, 
    }
}
</script>

<style scoped>
.details {
    right: -100vw;
    transition: 0.3s ease;
    width: 76.5vw;
    top: 98px;
    z-index: 999;
    height:calc(100vh - 98px);
}
.details.show {
    right: 0;
}

.dropdown-menu {
    border-radius: 3px;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
    border: 0.4px solid #ffffff;
    padding: 0;
    width: 20vw;
}

aside {
    width: 45vw;
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    transition: 0.3s ease;
}

.container {
    max-width: 100%;
}

.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.bg-primary {
    background-color: var(--primary-color) !important;
}

.text-primary {
    color: var(--primary-color) !important;
}

@media screen and (max-width: 991px) {
    aside.left {
        position: absolute;
        left: -100vw;
        width: 100vw;
        z-index: 999;
        background: #fff;
        height: calc(100vh - 98px) !important;
    }

    aside.left.show {
        left: 0;
    }

    aside.right {
        position: absolute;
        left: -100vw;
        width: 100vw;
        z-index: 999;
        background: #fff;
        height: calc(100vh - 98px) !important;
    }

    aside.right.show {
        left: 0;
    }

    .container {
        width: 100%;
        max-width: 100%;
    }

    .details {
        width: 100vw;
    }
}

.side-menu nav {
    margin-bottom: 0;
}

.side-menu .nav-link {
    border-radius: 4px;
    padding: 5px 10px;
    font-weight: 600;
    color: #585858;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    height: 38px;
}

.side-menu .nav-link:hover, .side-menu .nav-link.nav-active {
    background: #efefef;
}

.option-item {
    padding: 0 7px;
    border-radius: 4px;
    justify-content: center;
    transition: 0.3s;
    font-size: 19px;
    font-weight: 500;
}

.option-item:hover {
    background: #c9c9c96b;
}

.dropdown-toggle::after {
    display: none !important;
}

.dropdown-item {
    font-size: 14px;
    font-weight: 600;
    color: #424242d4;
    padding: 7px 16px;
}

.dropdown-item .mdi {
    margin-right: 10px;
    opacity: 0.4;
}

.dropdown-item.active, .dropdown-item:active {
    background-color: #6696e8;
    color: #fff;
}

</style>